module.exports = __webpack_public_path__ + "genna_rations_farm.8f117330a6007c88105427343f28f3fa.png";